<ngx-gov-co-shd-app-header-auth>
  <div *ngIf="showViewHTMLComponent" shd-container-router-component>
    <div class="container-shd-component-menu-panel-right">
      <div class="row-shd-component-menu-panel-right">
        <div class="col-main-shd-component-menu-panel-right">
          <nav aria-label="breadcrumb-shd-component-menu-panel-right">
            <ol class="breadcrumb-shd-component-menu-panel-right">
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)">Mis impuestos</a>
              </li>
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)" class="active">Retención ICA</a>
              </li>
            </ol>
          </nav>
          <h1 class="page-title-shd-component-menu-panel-right"><b>Retención ICA</b></h1>

          <div class="container-tabs-items">
            <div class="tab-item" [class.active]="tabs[0]" (click)="changeTab(2)" (keydown.enter)="changeTab(2)" tabindex="0" aria-label="Declaraciones presentadas">
              <span>Declaraciones presentadas</span>
            </div>
          </div>
          <div>
            <app-declaraciones-presentadas-reteica *ngIf="tabs[0]"></app-declaraciones-presentadas-reteica>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-gov-co-shd-app-header-auth>